import BaseTextarea from './base-textarea'

export default {
    install: function(Vue) {
        Vue.component('BaseTextarea', BaseTextarea)
    }
}